const reqwest = require('reqwest/reqwest.min');
const endpoints = require('endpoint/endpoint-service.js');
const ExceptionService = require('exceptions/exception-service.js');
const Utils = require('core-helpers/utils.js');
const Q = require('q');

const ContactFormService = (function (root, doc, undefined) {

    const filename = 'contact-form-service.js';
    const BUSUU_ADDRESS = '50 Finsbury Square, London EC2A 1HD';
    const MAP_LAT = 51.522251;
    const MAP_LONG = -0.087090;
    const BUSUU_LAT = 51.520424;
    const BUSUU_LONG = MAP_LONG;

    /**
     * Posts USER contact form to the backend
     * @param  {String} endpoint | endpoint key name
     * @param  {Object} params
     * @return {Promise}
     */
    const postContactForm = (endpoint, data) => {

        let deferred = Q.defer();

        const onSuccess = (response) => {
            if(response) {
                deferred.resolve(response);
            } else {
                onError({
                    message: 'bad response format',
                    error: response
                });
            }
        };

        const onError = (error) => {
            ExceptionService.handle('warning', {
                filename: filename,
                message: 'postContactForm() - Email post failure',
                data: error
            });
            deferred.reject(error);
        };

        var request = {
            url: endpoints.generateEndpoint(endpoint),
            method: 'POST',
            data: data,
            withCredentials: false
        };

        reqwest(request).then(onSuccess, onError);
        return deferred.promise;
    };

    /**
     * Sets all default options for the google map
     * @param  {Array} styles - all styling for the black & white map
     * @return {Object}
     */
    const getMapOptions = (styles) => {
        return {
            center: {
                lat: MAP_LAT,
                lng: MAP_LONG
            },
            zoom: 16,
            disableDefaultUI: true,
            scrollwheel: false,
            backgroundColor: '#eeeeee',
            styles: styles
        };
    };

    /**
     * Sets the options for the map marker
     * @param  {Object} map - map constructor
     * @param  {Object} mapIcon - pin constructor
     * @return {Object}
     */
    const getMarkerOptions = (map, mapIcon) => {
        return {
            position: {
                lat: BUSUU_LAT,
                lng: BUSUU_LONG
            },
            map: map,
            title: BUSUU_ADDRESS,
            icon: mapIcon
        };
    };

    /**
     * All custom styles for the black & white map style
     * @return {Array}
     */
    const getMapStyles = () => {
        return [
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{color: '#e9e9e9'},{lightness: 17}]
            },
            {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [{color: '#f5f5f5'},{lightness: 20}]
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [{color: '#ffffff'},{lightness:17}]
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [{color: '#ffffff'},{lightness: 29},{weight: 0.2}]
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers:[{color: '#ffffff'},{lightness: 18}]
            },
            {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers:[{color: '#ffffff'},{lightness: 16}]
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [{color: '#f5f5f5'},{lightness: 21}]
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers:[{color: '#dedede'},{lightness: 21}]
            },
            {
                elementType: 'labels.text.stroke',
                stylers:[{visibility: 'on'},{color: '#ffffff'},{lightness: 16}]
            },
            {
                elementType: 'labels.text.fill',
                stylers: [{saturation: 36},{color: '#333333'},{lightness: 40}]
            },
            {
                elementType: 'labels.icon',
                stylers:[{visibility:'off'}]
            },
            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers:[{color:'#f2f2f2'},{lightness:19}]
            },
            {
                featureType: 'administrative',
                elementType:'geometry.fill',
                stylers: [{color:'#fefefe'},{lightness:20}]
            },
            {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [{color:'#fefefe'},{lightness:17},{weight:1.2}]
            }
        ];
    };

    return {
        postContactForm: postContactForm,
        getMapOptions: getMapOptions,
        getMarkerOptions: getMarkerOptions,
        getMapStyles: getMapStyles
    };

})(window,document);

module.exports = ContactFormService;
